import React from "react";
import Editor from "@monaco-editor/react";

function EditorComponent(props) {
  return (
    <div className="editor-container">
      <Editor
        width="100%"
        height={props.height ?? "70vh"}
        language={props.config?.language ?? "javascript"}
        theme="light"
        path={props.config?.fileName ?? ""}
        value={props.data ?? ""}
        onChange={(value) => props.handleCodeChange(value)} 
        options={{
          fontSize: 13,
          fontFamily: "'Fira Code', monospace",
          fontLigatures: true,
          minimap: { enabled: false },
          lineNumbers: "on",
          readOnly: props.disabled ?? false,
          wordWrap: "on",
          folding: true,
          scrollBeyondLastLine: false,
          automaticLayout: true,
          suggestOnTriggerCharacters: true,
          acceptSuggestionOnEnter: "on",
          highlightActiveLine: true,
          matchBrackets: true,
          cursorStyle: "line",
          inlineSuggest: true,
          quickSuggestions: true,
          snippetSuggestions: "top",
          wordBasedSuggestions: true,
          formatOnType: true,
          autoClosingBrackets: true,
        }}
      />
    </div>
  );
}

export default EditorComponent;
